import Vue from 'vue'
import Vuex from 'vuex'
import { getUser, setUser } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoadding: false,
	catch_components: []
  },
  mutations:{
      GET_CATCHE_COMPONENTS (state, data) {
        state.catch_components = data
      }
  }
});

